import { useLang } from "@/i18n/LanguageContext";

export const Marquee = () => {
  const { t } = useLang();
  const items = t.marquee;

  const Track = ({ hidden }) => (
    <div aria-hidden={hidden || undefined} className="flex shrink-0 items-center">
      {items.map((item, i) => (
        <div key={i} className="flex items-center">
          <span className="whitespace-nowrap px-8 font-mono text-xs uppercase tracking-[0.3em] text-ink-muted sm:text-sm">
            {item}
          </span>
          <span className="h-1.5 w-1.5 rotate-45 bg-signal/70" />
        </div>
      ))}
    </div>
  );

  return (
    <div className="relative border-y border-white/8 bg-night-2/60 py-6">
      <div className="mask-fade-x overflow-hidden">
        <div className="flex w-max animate-marquee hover:[animation-play-state:paused]">
          <Track />
          <Track hidden />
        </div>
      </div>
    </div>
  );
};

export default Marquee;
